// War Effort Simulated Bot Log - dev-only UI showing bot actions
// Renders when devModeActive && isPlayer1 && missionData?.player2_simulated_at

import React, { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function WarEffortBotLog({ missionId }) {
  const [entries, setEntries] = useState([]);
  const [energy, setEnergy] = useState(null);
  const [orders, setOrders] = useState(null);
  const [error, setError] = useState(null);

  const fetchLog = useCallback(async () => {
    if (!missionId) return;
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/war-effort/mission/${missionId}/bot-log`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || 'Failed to fetch bot log');
      }
      const data = await res.json();
      setEntries(data.entries || []);
      setEnergy(data.energy);
      setOrders(data.orders);
      setError(null);
    } catch (err) {
      setError(err.message);
      setEntries([]);
    }
  }, [missionId]);

  useEffect(() => {
    fetchLog();
    const interval = setInterval(fetchLog, 5000);
    return () => clearInterval(interval);
  }, [fetchLog]);

  return (
    <div
      style={{
        position: 'fixed',
        top: '100px',
        right: '20px',
        width: '280px',
        maxHeight: '400px',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        border: '2px solid rgba(78, 205, 196, 0.5)',
        borderRadius: '8px',
        padding: '12px',
        zIndex: 1001,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          color: '#4ECDC4',
          fontWeight: 'bold',
          marginBottom: '10px',
          fontSize: '13px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>Bot Log</span>
        <span style={{ color: '#ccc', fontWeight: 'normal', fontSize: '12px' }}>
          {energy !== null && `Energy: ${energy}`}
          {energy !== null && orders !== null && ' · '}
          {orders !== null && `Orders: ${orders}`}
        </span>
      </div>
      {error && (
        <div style={{ color: '#e74c3c', fontSize: '11px', marginBottom: '8px' }}>
          {error}
        </div>
      )}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          fontSize: '11px',
          fontFamily: 'monospace',
          color: '#ccc',
          lineHeight: 1.5
        }}
      >
        {entries.length === 0 ? (
          <div style={{ color: '#777', fontStyle: 'italic' }}>No bot actions yet</div>
        ) : (
          entries.map((e, i) => (
            <div
              key={i}
              style={{
                marginBottom: '4px',
                padding: '2px 0',
                borderBottom: i < entries.length - 1 ? '1px solid rgba(255,255,255,0.1)' : 'none'
              }}
            >
              <span style={{ color: '#888', marginRight: '6px', fontSize: '10px' }}>
                {e.timestamp ? new Date(e.timestamp).toLocaleTimeString() : ''}
              </span>
              {e.message}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default WarEffortBotLog;
